import { jsx } from "react/jsx-runtime";
import { useState } from "react";
import { generateWebpPath } from "@nxplatform/platform-settings/setup-utils";
var LoadingOptions = /* @__PURE__ */ ((LoadingOptions2) => {
  LoadingOptions2["lazy"] = "lazy";
  LoadingOptions2["eager"] = "eager";
  return LoadingOptions2;
})(LoadingOptions || {});
const LazyImage = ({
  title,
  alt,
  src,
  className,
  draggable = false,
  dataTest = "",
  onErrorCapture = () => {
  },
  onLoad,
  style = {},
  height = null,
  width = null,
  loading = "lazy",
  webpSupport = window.webpSupport,
  imgRef,
  noHideOnError = false
}) => {
  const [hide, setHide] = useState(false);
  const onImageError = (e) => {
    onErrorCapture(e);
    if (e && !noHideOnError) {
      setHide(true);
    }
  };
  if (hide) return null;
  return /* @__PURE__ */ jsx(
    "img",
    {
      src: generateWebpPath({ path: src, webpSupport }),
      title,
      alt,
      className: className || "",
      onLoad,
      onError: onImageError,
      loading,
      decoding: "async",
      height,
      width,
      draggable,
      "data-test": dataTest,
      style,
      ref: imgRef
    }
  );
};
export {
  LazyImage,
  LoadingOptions
};
